import React, { useEffect, useState } from 'react';
import { Button, Select, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { exportToCSV, getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Can from '../../permission/Can';

const AgentList = () => {
    const navigate = useNavigate();
    const [exportData, setExportData] = useState([])
    const columns = [
        {
            title: 'First Name',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Last Name',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'No. Of Jobs',
            dataIndex: 'job_count',
            key: 'job_count',
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render : (_, data) => {
                const date = new Date(data?.createdAt);
                return date.toLocaleDateString('en-CA')
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Can permission="edit_agent">
                        <Button onClick={() => navigate('/agent/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    </Can>
                    <Button onClick={() => navigate('/jobs/' + data?._id)} icon={<EyeOutlined />} size="small">View Jobs</Button>
                    <Button onClick={() => navigate('/view-attendance/' + data?._id, { state: { data: `${data?.first_name} ${data?.last_name}` } })} icon={<EyeOutlined />} size="small">View Attendance</Button>
                </Space>
            ),
        },
    ];

    const searchedData = async (data) => {
        setExportData(data)
    }

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Agents</h1>
                <span>
                    <Button style={{ marginRight: 5 }} type="primary" onClick={() => exportToCSV(exportData, 'agents.csv', columns)}>Export To CSV</Button>
                    <Can permission="create_agent">
                        <Button type="primary" onClick={() => navigate('/agent/add')}>Add Agent</Button>
                    </Can>
                </span>
            </div>
            <TableComponent
                listData={getUsersList}
                roleType="agent"
                selectPlaceHolder="Select Agent"
                columns={columns}
                searchedData={searchedData}
                placeholder="Search agents..."
                listName="User"
            />
        </div>
    );
};

export default AgentList;

